import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import {
  BBWTMessageService,
  CapacityMatchingService,
  CustomerService,
  EngineiusRegionService,
  IDriverService,
  JobsDeploymentService,
  JobUnassignedReasonService,
  MapService,
  OrganisationsService,
  SettingsService,
  SupplierInboxJobsService,
  SupplierJobInteractionService,
  SupplierScheduleService,
  TaskService,
  UserService,
} from '../../services';
import { IDriverDTO } from '../../interfaces/driver';
import { compare, deepClone } from 'fast-json-patch';
import { ITaskDTO, TaskSearchRequestDTO, TaskSearchResultDTO } from '../../interfaces/task-info';
import { IDriverFilter } from '../../interfaces/driver-filter';
import { Subject } from 'rxjs';
import { uniqBy } from 'lodash';
import {
  ISupplierAvailabilityException,
  SupplierAvailabilityStateEnum,
} from '../../interfaces/supplier-schedule';
import { TaskCollectionTravelMode } from '../../enums/task-collection-travel-mode.enum';
import { IFacetedJob } from '../../interfaces/faceted-inbox-task';
import { RequestChannelType } from '../../enums/request-channel-type';
import { JobAcceptResult } from '../../enums/job-accept-result';
import { ISupplier } from '../../interfaces/supplier';
import { ISystemSettings } from '../../interfaces/system-settings';
import { IHandoverTime } from '../../interfaces/handover-time';
import { CdkDragMove } from '@angular/cdk/drag-drop';
import { JobStatus } from '../../enums/job-status';
import { IntroJSService } from '../../services/introjs.service';
import { TaskScheduleDTO } from '../task-supplier-schedule/task-supplier-schedule';
import { AllocateJobDTO } from '../../interfaces/allocate-job';
import { AcceptJobDTO } from '../../interfaces/accept-job';
import { LocalStorage } from '@ng-idle/core';
import moment from 'moment';
import { SupplierJobChannel } from '../../enums/supplier-job-channel';
import isEqual from 'lodash/isEqual';

interface IDriverObject {
  id?: number;
  driver: IDriverDTO;
  tasks: ITaskInteractiveDTO[];
  nickName: string;
  driverId: number;
  position?: number;
  identifier: number;
  visible: boolean;
  supplier: ISupplier;
  availability: ISupplierAvailabilityException[];
}

interface ILineData {
  id: string;
  fromDateTime: string;
  toDateTime: string;
  data?: ITaskDTO | IScheduleNoteDTO | ITaskInteractiveDTO;
  driver?: IDriverObject;
  type?: string;
  template: TemplateRef<any>;
}

interface ITaskInteractiveDTO extends ITaskDTO {
  xOfTotal?: number;
  totalTasksInJob?: number;

  previousDriver?: IDriverDTO;
  reschedule?: { pickupDateTime: Date; dropoffDateTime: Date };
  rowNumber?: number;
}

interface IScheduleNoteDTO {
  id?: number;
  driverId?: number;
  isVisible?: boolean;
  note?: string;
  noteDateFrom?: string;
  noteDateTo?: string;
}

interface IContext {
  id?: string;
  multipleDrivers?: boolean;
  containerWidth?: string;
  hasStart?: boolean;
  hasEnd?: boolean;
  style: {
    top?: string;
    left?: string;
    width?: string;
    height?: string;
  };
  innerStyle?: {
    'background-color'?: string;
  };
  textStyle?: string;
  leftStyle?: {
    'background-color'?: string;
  };
  leftClass?: string;
  rightClass?: string;
  driver?: IDriverDTO;
  taskInfo?: ITaskInteractiveDTO;
  noteInfo?: IScheduleNoteDTO;
  handoverInfo?: IHandoverTime;
  popupCode?: string;
  pickupHandoverStyle?: { width?: string };
  dropoffHandoverStyle?: { width?: string };
  editMode?: boolean;
}

@Component({
  selector: 'interactive-schedule',
  templateUrl: './interactive-schedule.component.html',
  styleUrls: ['./interactive-schedule.component.scss'],
})
export class InteractiveScheduleComponent implements OnInit, AfterViewInit {
  math = Math;

  @ViewChild('gridContainer', { read: ViewContainerRef }) gridContainer: ViewContainerRef;
  @ViewChild('gridItemTemplate') gridItemTemplate: TemplateRef<any>;
  @ViewChild('allowedAreaTemplate') allowedAreaTemplate: TemplateRef<any>;
  @ViewChild('postItTemplate') postItTemplate: TemplateRef<any>;
  @ViewChild('unavailableAreaTemplate') unavailableAreaTemplate: TemplateRef<any>;
  @ViewChild('pickupWindowAreaTemplate') pickupWindowAreaTemplate: TemplateRef<any>;
  @ViewChild('dropoffWindowAreaTemplate') dropoffWindowAreaTemplate: TemplateRef<any>;
  @ViewChild('outOfHoursAreaTemplate') outOfHoursTemplate: TemplateRef<any>;
  @ViewChild('pickupOutOfBoundsTemplate') pickupOutOfBoundsTemplate: TemplateRef<any>;
  @ViewChild('dropoffOutOfBoundsTemplate') dropoffOutOfBoundsTemplate: TemplateRef<any>;
  @ViewChild('supplierChangeDialog') supplierChangeDialog: boolean;
  @ViewChild('acceptJobDialog') acceptJobDialog: boolean;
  @ViewChild('confirmAvailabilityDialog') confirmAvailabilityDialog: boolean;
  @ViewChild('editPostItDialog') editPostItDialog: boolean;

  driverFilter: IDriverFilter = { filters: {} };

  subject: Subject<any> = new Subject();
  newDriver: IDriverObject;
  unassignReasons: { label: string; value: number }[];
  taskCollectionTravelMode = TaskCollectionTravelMode;

  private _inputJobs: IFacetedJob[] = [];
  private supplierTasks: { [key: number]: TaskSearchResultDTO } = {};
  private inputJobIds: number[] = [];
  capableSuppliers: number[] = [];
  multipleDrivers: boolean = true;
  private taskUpdating: boolean;
  savingChanges = false;
  pendingChanges = 0;

  @Output() pendingChangesUpdate = new EventEmitter<number>();
  @Output() dateChangeEvent = new EventEmitter<any>();
  @Output() inputJobsChangeEvent = new EventEmitter<any>();
  supplierAvailable: {};
  maxPickupDeviation: number;
  maxDropoffDeviation: number;
  private rescheduleTask: ITaskInteractiveDTO;
  private defaultHandoverTimes: IHandoverTime[];
  private originalTaskDates: any;
  private originalHeight: number;
  private allTaskDivs: Element[];
  public jobStatusEnum = JobStatus;
  private postIts: IScheduleNoteDTO[] = [];

  public enablePostIts = false;
  public currentNote: IScheduleNoteDTO = {};
  public currentContext: IContext;
  private previousJobList: IFacetedJob[] = [];
  public taskMapCode: {} = {};
  mousePosition: { x: number; y: number };
  overlappingTasks: ITaskDTO[] = [];
  private dragging: boolean = false;
  dayRows: any[] = [];
  layerMode: boolean;
  private originalX: number;
  private minDragWidth: number;

  @Input() set inputJobs(value: IFacetedJob[]) {
    this.inputJobIds = value.map((x) => x.jobId);
    this._inputJobs = value;
    if (!isEqual(value, this.previousJobList) && value != null) {
      this.refresh('InputJobs');
    }
    this.previousJobList = [...value];

    /*
  } else {
    // clear jobs list


    this.inputJobIds = [];
    this._inputJobs = [];
    this.previousJobList = [];
  }

     */
  }

  get inputJobs(): IFacetedJob[] {
    return this._inputJobs;
  }

  private _supplierIds: number[] = [];
  @Input() set supplierIds(value: number[]) {
    let previousValue = this._supplierIds;
    this._supplierIds = value;
    this.suppliersChanged(this._supplierIds, previousValue);
  }

  get supplierIds(): number[] {
    return this._supplierIds;
  }

  @Input() isVME: boolean;

  public get jobConfirmText() {
    return this.isVME ? 'Allocate Job' : 'Accept Job';
  }

  private staticMapSize: string = '340x200';
  public supplierId = 2139;
  public tasks: ITaskInteractiveDTO[] = [];
  public hourRange = [];
  public workingHours = true;
  public daysInView = 10;
  public days = [];
  public startDate = new Date();
  private dayRow: {};
  private originalEvent: any;
  private moveMode: string;
  drivers: IDriverObject[] = [];
  private onlyDriverId: number;
  supplierDrivers: IDriverDTO[];
  private savedState: ITaskInteractiveDTO[];
  activeGrid: boolean = true;
  minDate: string;
  maxDate: string;

  public selectedTask: ITaskInteractiveDTO = null;
  topLayer: any;
  suppliers: any[] = [];
  selectedSuppliers: number[] = [];
  regions: any;
  unassignReasonId: any;
  unassignComment: any;
  showCalendar = false;
  loadingDrivers = false;
  public jobStatusName: number[] = [];
  showOverlappingTasks: any;

  // This function will be called with every potential position change.
  constrainPosition = (point: { x: number; y: number }, dragRef) => {
    console.log('POINT X ', point.x);
    return {
      x: Math.max(800, point.x),
      y: point.y,
    };
  };

  constructor(
    private userService: UserService,
    private taskService: TaskService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private mapService: MapService,
    private supplierInboxJobsService: SupplierInboxJobsService,
    private regionService: EngineiusRegionService,
    private customerService: CustomerService,
    private capacityMatchingService: CapacityMatchingService,
    private jobsDeploymentService: JobsDeploymentService,
    private jobUnassignedReasonService: JobUnassignedReasonService,
    public messageService: BBWTMessageService,
    private organisationService: OrganisationsService,
    private datePipe: DatePipe,
    private driverService: IDriverService,
    private supplierScheduleService: SupplierScheduleService,
    private systemSettingsService: SettingsService,
    private localStorage: LocalStorage,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    private introJs: IntroJSService,
    private supplierJobInteractionService: SupplierJobInteractionService,
  ) {
    this.loadSettings();

    for (const js in JobStatus) {
      if (Number(js)) {
        const ms: JobStatus = JobStatus[js as keyof typeof JobStatus];
        this.jobStatusName[js] = ms;
      }
    }
  }

  ngOnInit() {
    if (this.isVME) {
      this.setCSSVariable('--legendRight', '270px');
    }

    this.userService.getCurrentUserOrg().then(async () => {
      this.refresh('OnInit');
    });

    this.jobUnassignedReasonService.getReasons({ isActive: true }).then((x) => {
      this.unassignReasons = x.map((y, z) => {
        return { label: y.description, value: y.id };
      });
    });

    this.systemSettingsService.GetSystemSettings().then((data: ISystemSettings) => {
      if (data != null) {
        this.maxPickupDeviation = data.interactiveScheduleMaxPickupAdjustment;
        this.maxDropoffDeviation = data.interactiveScheduleMaxDropoffAdjustment;
      }
    });

    this.initDays(null);
    this.initHours();
    this.initHandovers();
  }

  loadSettings() {
    const settingsJSON = this.localStorage.getItem('interactive-schedule-settings');

    if (settingsJSON == null) {
      this.layerMode = true;
    } else {
      const settings = JSON.parse(settingsJSON);

      if (settings['layerMode']) {
        this.layerMode = settings['layerMode'] === 'true';
      }

      if (settings['startDate']) {
        const dateTime = new Date(settings['startDate']);

        // Only recall the saved date if its in the future
        if (dateTime >= new Date()) {
          this.startDate = dateTime;
        }
      }
    }
  }

  saveSettings(from) {
    this.localStorage.setItem(
      'interactive-schedule-settings',
      JSON.stringify({
        startDate: this.startDate,
        layerMode: this.layerMode.toString(),
      }),
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.introJs.interactiveSchedule();
    }, 500);
  }

  showHelp() {
    this.introJs.showHelp();
  }

  refresh(source) {
    this.supplierDrivers = [];
    this.loadingDrivers = true;

    this.getDrivers().then(async () => {
      this.loadingDrivers = false;

      await this.loadTaskData({
        supplierIds: this.supplierIds,
        jobIds: this.inputJobs.map((x) => x.jobId),
        specifiedPickupTimeFrom: this.minDate + ' 00:00:00',
        specifiedDropoffTimeTo: this.maxDate + ' 23:59:59',
      }).then(() => {});
    });
  }

  plotNewData(source) {
    this.initDrivers('PlotNewData');
    this.redrawGridItems();
    this.saveState();
  }

  initDrivers(source) {
    this.drivers = [];

    this.supplierDrivers.forEach((driver, y) => {
      this.drivers.push({
        driver: driver,
        nickName: driver.nickName || driver.firstName,
        driverId: driver.id,
        supplier: driver.supplier,
        identifier: y,
        visible: true,
        availability: driver.unavailable,
        tasks: this.tasks.filter(
          (z) =>
            (z.driver == null && driver.id == null) ||
            (z.driver != null && z.driver.id == driver.id),
        ),
      });
    });

    // For angular
    this.drivers = [...this.drivers];
  }

  updateDriverCount() {
    let visibleDrivers = this.drivers.filter((x) => x.visible == true && x.tasks.length > 0);
    let visibleDriverCount = visibleDrivers.length;

    visibleDrivers.forEach((x, y) => {
      x.position = y;
    });

    this.setCSSVariable('--drivers', visibleDriverCount.toString());
  }

  allocateTaskRows() {
    // Iterate each day on the grid
    this.days.forEach((day) => {
      const rowDate = moment(day).format('YYYY-MM-DD');

      let rowTasks = [[]];
      let allTasks = [];

      this.drivers.forEach((driver) => {
        allTasks = [...allTasks, ...driver.tasks];
      });

      // Get a list of tasks for this day, ordered by earliest pickup
      allTasks
        .filter(
          (y) =>
            moment(y.taskSupplierSchedule.specifiedPickUpTime).format('YYYY-MM-DD') <= rowDate &&
            moment(y.taskSupplierSchedule.specifiedDropOffTime).format('YYYY-MM-DD') >= rowDate,
        )
        .sort((a, b) => {
          return a.taskSupplierSchedule.specifiedPickUpTime.localeCompare(
            b.taskSupplierSchedule.specifiedPickUpTime,
          );
        })
        .forEach((task) => {
          // EmptyRow denotes if this bar will be allocated its own row on the grid
          // false = new row, true = use existing row
          let emptyRow = false;
          let rowNumber = 0;

          // Limit it to 10 rows to prevent it spinning out
          while (!emptyRow && rowNumber < 10) {
            // Get a list of jobs on this row
            const tasksOnRow = rowTasks[rowNumber];

            if (tasksOnRow != undefined && tasksOnRow.length > 0) {
              if (
                tasksOnRow[tasksOnRow.length - 1].taskSupplierSchedule.specifiedDropOffTime <=
                task.taskSupplierSchedule.specifiedPickUpTime
              ) {
                emptyRow = true;
              }
            } else {
              emptyRow = true;
            }

            if (!emptyRow) {
              rowNumber++;
            }
          }

          if (rowTasks[rowNumber] === undefined) {
            rowTasks[rowNumber] = [];
          }

          rowTasks[rowNumber].push(task);
          task.rowNumber = rowNumber;
        });

      // Store the number of rows of data for each day
      this.dayRows[rowDate] = rowTasks.length;
    });

    console.log('DAY ROWS ', this.dayRows);
  }

  redrawGridItems() {
    // Update the visible driver count
    this.updateDriverCount();

    // Remove previous items
    this.gridContainer.clear();

    if (this.layerMode != false) {
      this.allocateTaskRows();
    }

    this.drivers
      .filter((x) => x.visible == true)
      .forEach((d) => {
        d.tasks.forEach((t: ITaskInteractiveDTO, index) => {
          this.plotTask(t, d);
        });
      });

    this.plotOutOfHours();

    if (this.enablePostIts) {
      this.plotPostIts();
    }
  }

  plotTask(task: ITaskInteractiveDTO, driver) {
    // If we're displaying 7:00-18:00
    if (
      this.workingHours &&
      // If the dropoff hour is after 18:00
      (moment(task.taskSupplierSchedule.specifiedDropOffTime).hour() >
        this.hourRange[this.hourRange.length - 1] + 1 ||
        moment(task.taskSupplierSchedule.specifiedPickUpTime).hour() >
          this.hourRange[this.hourRange.length - 1] + 1 ||
        // Or if the pickup hour is before 7:00
        (moment(task.taskSupplierSchedule.specifiedPickUpTime).hour() < this.hourRange[0] &&
          // and the dropoff day is the same day
          moment(task.taskSupplierSchedule.specifiedDropOffTime).day() ==
            moment(task.taskSupplierSchedule.specifiedPickUpTime).day()))
    ) {
      this.toggleHours();
    }

    this.drawTimeLines({
      id: 'task-' + task.id,
      fromDateTime: task.taskSupplierSchedule.specifiedPickUpTime,
      toDateTime: task.taskSupplierSchedule.specifiedDropOffTime,
      data: task,
      driver: driver,
      template: this.gridItemTemplate,
      type: 'task',
    });
  }

  getGridLeftFromPosition(startTimeDecimal) {
    return 'calc(var(--hourWidth) * ' + startTimeDecimal + ')';
  }

  async taskPopupCode(taskInfo, handoverTimes) {
    const dateOptions: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
    };

    const pue = new Date(taskInfo.pickupEarliestDateTime).toLocaleString('en-GB', dateOptions);
    const pul = new Date(taskInfo.pickupLatestDateTime).toLocaleString('en-GB', dateOptions);
    const doe = new Date(taskInfo.dropoffEarliestDateTime).toLocaleString('en-GB', dateOptions);
    const dol = new Date(taskInfo.dropoffLatestDateTime).toLocaleString('en-GB', dateOptions);

    const polylines = await this.mapService.GetRoutePolyLine({
      fromLatitude: taskInfo.pickupLocation.latitude,
      fromLongitude: taskInfo.pickupLocation.longitude,
      toLatitude: taskInfo.dropoffLocation.latitude,
      toLongitude: taskInfo.dropoffLocation.longitude,
      departureTime: taskInfo.earliestPickupDate,
    });

    return this.mapService.getStaticMapPath(
      'roadmap',
      this.mapService.buildMarkersFromTask(taskInfo),
      this.staticMapSize,
      1,
      null,
      [polylines],
    );
  }

  drawTimeLines(options: ILineData) {
    // Min/Max time range on the task (not schedule)
    let startDateTime = this.datePipe.transform(
      new Date(options.fromDateTime),
      'yyyy-MM-dd HH:mm',
      'Europe/London',
    );
    let endDateTime = this.datePipe.transform(
      new Date(options.toDateTime),
      'yyyy-MM-dd HH:mm',
      'Europe/London',
    );

    let startSplit = startDateTime.split(' ');
    let endSplit = endDateTime.split(' ');

    let startDateYMD = this.datePipe.transform(
      new Date(startDateTime),
      'yyyy-MM-dd',
      'Europe/London',
    );
    let endDateYMD = this.datePipe.transform(new Date(endDateTime), 'yyyy-MM-dd', 'Europe/London');

    let startTimeDecimal = this.timeStringToFloat(startSplit[1]) - this.hourRange[0];
    let endTimeDecimal = this.timeStringToFloat(endSplit[1]) - this.hourRange[0];

    // Get a list of days between start + end date
    let dayList = this.daysArray(startDateYMD, endDateYMD);

    let left = '';
    let width = '';

    dayList.forEach(async (x) => {
      // Line is outside of the chart range
      if (!(x.ymd in this.dayRow)) {
        return null;
      }

      let rowNumber = this.dayRow[x.ymd];
      let elementId = options.id + '-' + x.ymd + '-' + rowNumber;
      let leftClass = 'rounded bg';
      let rightClass = 'rounded bg';

      let rowsPerDay = this.dayRows[x.ymd];

      let position = 0;
      let top = '';
      let height = '';

      if (this.layerMode != false && options.data != undefined) {
        position = (options.data as ITaskInteractiveDTO).rowNumber
          ? (options.data as ITaskInteractiveDTO).rowNumber
          : 0;
        top =
          'calc(calc(var(--rowHeight) * ' +
          rowNumber +
          ') + (var(--rowTaskHeight' +
          rowsPerDay +
          ') * ' +
          position +
          '))';
        height = 'var(--rowTaskHeight' + rowsPerDay + ')';
      } else {
        position = options.driver ? options.driver.position : 0;
        top =
          'calc(calc(var(--rowHeight) * ' +
          rowNumber +
          ') + (var(--taskHeight) * ' +
          position +
          '))';
      }

      let pickupHandoverWidth = '';
      let dropoffHandoverWidth = '';

      let hasStart = true;
      let hasEnd = true;

      // If today is the start day
      if (x.ymd.localeCompare(startDateYMD) == 0) {
        left = this.getGridLeftFromPosition(startTimeDecimal);

        // and today is the end day
        if (x.ymd.localeCompare(endDateYMD) == 0) {
          let durationDecimal = endTimeDecimal - startTimeDecimal;
          width = 'calc(var(--hourWidth) * ' + durationDecimal + ')';
        } else {
          // we end on a different day
          width = 'calc(var(--gridWidth) - ' + left + ')';
          rightClass = 'zigzag';
          hasEnd = false;
        }
      } else {
        // if today is not the start day
        left = '0px';
        leftClass = 'zigzag';
        hasStart = false;

        // If today is the end day
        if (x.ymd.localeCompare(endDateYMD) == 0) {
          width = 'calc(var(--hourWidth) * ' + endTimeDecimal + ')';
        } else {
          width = 'var(--gridWidth)';
          rightClass = 'zigzag';
          hasEnd = false;
        }
      }

      const selectedTaskColour = '#607D8B';

      let innerStyleRGB = selectedTaskColour;

      if (options.driver != null) {
        innerStyleRGB = this.driver2rgb(options.driver);
      }

      let context: IContext = {
        id: elementId,
        multipleDrivers: this.multipleDrivers,
        containerWidth: width,
        hasStart: hasStart,
        hasEnd: hasEnd,
        style: {
          top: top,
          left: left,
          width: width,
          height: height,
        },
        innerStyle: {
          'background-color': innerStyleRGB,
        },
        textStyle: this.driver2rgbText(options.driver),
        leftStyle: {
          'background-color': innerStyleRGB,
        },
        leftClass: leftClass,
        rightClass: rightClass,
        driver: options.driver,
      };

      let popupCode = '';

      if (options.data) {
        // PUT TASK SPECIFIC CODE HERE
        if (options.type == 'task') {
          const taskInfo = options.data as ITaskInteractiveDTO;

          context.taskInfo = taskInfo;
          const handoverTimes =
            taskInfo.order.customer.handoverTimes.length > 0
              ? taskInfo.order.customer.handoverTimes[0]
              : null;

          if (
            this.inputJobIds &&
            taskInfo.order.job != null &&
            this.inputJobIds.includes(taskInfo.order.job.id)
          ) {
            context.leftStyle['background-color'] = selectedTaskColour;
          }

          if (handoverTimes != null) {
            pickupHandoverWidth =
              'calc(var(--columnWidth2) * ' + handoverTimes.pickupHandoverMinutes / 60 + ')';
            dropoffHandoverWidth =
              'calc(var(--columnWidth2) * ' + handoverTimes.dropoffHandoverMinutes / 60 + ')';
          }

          context.handoverInfo = taskInfo.order.customer.handoverTimes[0];
          context.pickupHandoverStyle = { width: pickupHandoverWidth };
          context.dropoffHandoverStyle = { width: dropoffHandoverWidth };
        }

        if (options.type == 'note') {
          context.noteInfo = options.data as IScheduleNoteDTO;
        }
      }

      this.gridContainer.createEmbeddedView(options.template, {
        context: context,
      });
    });
  }

  driver2rgb(driver: IDriverObject) {
    if (driver == null || driver.driver.id == null) {
      return '#607D8B';
    }

    let str = driver.nickName + '-' + (driver.driver.id ? driver.driver.id.toString() : 'null');

    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let colour = '#';
    for (let i = 0; i < 3; i++) {
      let value = (hash >> (i * 8)) & 0xff;
      colour += ('00' + value.toString(16)).substr(-2);
    }

    return colour;
  }

  driver2rgbText(driver: IDriverObject) {
    let rgb = this.driver2rgb(driver);

    let color = rgb.charAt(0) === '#' ? rgb.substring(1, 7) : rgb;
    let r = parseInt(color.substring(0, 2), 16); // hexToR
    let g = parseInt(color.substring(2, 4), 16); // hexToG
    let b = parseInt(color.substring(4, 6), 16); // hexToB
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? 'dark' : 'light';
  }

  daysArray(start, end) {
    let arr = [];
    const startMoment = moment(start);
    const endMoment = moment(end);

    while (startMoment <= endMoment) {
      arr.push(new Date(startMoment.format('YYYY-MM-DD')));
      startMoment.add(1, 'days');
    }

    return arr.map((x) => {
      return { date: x, ymd: moment(x).format('YYYY-MM-DD') };
    });
  }

  toggleHours() {
    this.workingHours = !this.workingHours;
    this.initHours();
    this.redrawGridItems();
  }

  initHours() {
    if (this.workingHours) {
      this.hourRange = this.range(7, 11);
    } else {
      this.hourRange = this.range(0, 24);
    }

    this.setCSSVariable('--columns', this.hourRange.length.toString());
  }

  range(start, count) {
    return Array.from({ length: count }, (_, i) => i + start);
  }

  initDays(startDate: Date) {
    // Use the date we've been passed, or use the date we've already got, or start today
    this.startDate = startDate || this.startDate || new Date();
    this.startDate.setHours(0, 0, 0);
    this.days = [];
    this.dayRow = {};
    const previousMinDate = this.minDate;

    this.minDate = null; // ?
    this.maxDate = null; // ?

    const rangeStart = moment(this.startDate).format('YYYY-MM-DD');
    const rangeEnd = moment(this.startDate)
      .add(this.daysInView - 1, 'days')
      .format('YYYY-MM-DD');

    let dayList = this.daysArray(rangeStart, rangeEnd);
    let cnt = 0;

    dayList.forEach((day) => {
      let ymd = day.ymd;
      this.days.push(day.date);
      this.dayRow[ymd] = cnt; // So we can find which row a date should be plotted on
      this.minDate = this.minDate == null ? ymd : this.minDate;
      this.maxDate = ymd;
      cnt++;
    });

    this.setCSSVariable('--rows', this.daysInView.toString());

    if (this.minDate != previousMinDate) {
      this.dateChangeEvent.emit({ minDate: this.minDate, maxDate: this.maxDate });
    }
  }

  timeStringToFloat(time) {
    let hoursMinutes = time.split(/[.:]/);
    let hours = parseInt(hoursMinutes[0], 10);
    let minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 60;
  }

  zoomDays(zoomIn: boolean) {
    this.daysInView = this.daysInView + (zoomIn == true ? -1 : 1);

    this.initDays(null);
    this.refresh('ZoomDays');
  }

  getIDComputedStyle(id: string) {
    return window.getComputedStyle(document.getElementById(id));
  }

  setCSSVariable(varName: string, value: string) {
    this.elementRef.nativeElement.style.setProperty(varName, value);
  }

  dragMove(context, $event: CdkDragMove<any>, direction) {
    const dragHandle = document.getElementById('resize-' + direction + '-' + context.id);
    const draggedBox = document.getElementById(context.id);
    this.dragging = true;

    this.setMoveMode(direction);

    // MOVING NOT STRETCHING
    if (direction == 'all') {
      const movement = document.getElementById(context.id).style.transform;

      Array.prototype.slice.call(this.allTaskDivs).forEach((element) => {
        if (element.id != context.id) {
          element.style.transform = movement;
        }
      });
    } else {
      // STRETCHING NOT MOVING
      this.ngZone.runOutsideAngular(() => {
        this.stretch($event, context, dragHandle, draggedBox, direction, context.hasStart);
      });
    }
  }

  stretch($event, context, dragHandle: HTMLElement, target: HTMLElement, handleName, hasStart) {
    const targetRect = target.getBoundingClientRect();
    const movementX = $event.event.movementX;
    const movementY = $event.event.movementY;

    if (handleName == 'right') {
      if (targetRect.width > this.minDragWidth || movementX > 0 || !hasStart) {
        const width = Math.max(targetRect.width + movementX, this.minDragWidth);
        target.style.width = width + 'px';
      }
    }

    if (handleName == 'left') {
      if (targetRect.width > this.minDragWidth || movementX < 0) {
        let leftStyle = window.getComputedStyle(target);

        target.style.left = this.px2int(leftStyle.left) + movementX + 'px';

        const newWidth = Math.max(targetRect.width - movementX, this.minDragWidth);
        target.style.width = newWidth + 'px';
      }
    }

    if (handleName == 'bottom') {
      let newHeight = targetRect.height + movementY;

      // A bar with a start date can't be shrunk, only grown
      if (hasStart && newHeight < this.originalHeight) {
        newHeight = this.originalHeight;
      }

      target.style.height = newHeight + 'px';
    }

    this.setAllHandleTransform(context.id);
  }

  setAllHandleTransform(id) {
    ['right', 'left', 'bottom'].forEach((position) => {
      const handle = document.getElementById('resize-' + position + '-' + id);
      this.setHandleTransform(handle, position);
    });
  }

  setHandleTransform(dragHandle: HTMLElement, position: string) {
    if (dragHandle != null) {
      if (position == 'bottom') {
        dragHandle.style.transform = `translate3d(0,0,0)`;
      } else {
        dragHandle.style.transform = `translate(0,0)`;
      }
    }
  }

  storeTaskDivs(id) {
    let parts = id.split('-');
    const prefix = [parts[0], parts[1]].join('-');
    const wildCard = "div[id^='" + prefix + "']";

    const matchingElements = document.getElementById('grid-inner').querySelectorAll(wildCard);
    this.allTaskDivs = Array.prototype.slice.call(matchingElements);
  }

  dragTaskStart($event: any, context: any) {
    const task = context.taskInfo;
    const driverInfo = context.driverInfo;

    this.originalEvent = $event;
    this.activeGrid = false;
    this.originalTaskDates = task;

    const cs = this.getIDComputedStyle(context.id);
    this.originalHeight = this.px2int(cs.height);
    this.minDragWidth = this.getHourWidth() / 2; // Min Task Duration, 30 minutes

    // Record the position of all the divs for this task so we can move them all at the same time when being dragged
    // (not resized)
    this.storeTaskDivs(context.id);

    /*
    this.drawTimeLines({
      id: "active",
      driver: driverInfo,
      fromDateTime: task.pickupEarliestDateTime,
      toDateTime: task.dropoffLatestDateTime,
      template: this.allowedAreaTemplate
    });
     */

    /* PLOT THE AREAS WHERE WE CANNOT DRAG TASKS TO - CONSIDER SUBROUTINE */
    let calendarStart = this.minDate + (this.workingHours ? ' 07:00' : ' 00:00');
    let calendarEnd = this.maxDate + (this.workingHours ? ' 18:00' : ' 23:00');

    if (task.pickupEarliestDateTime > calendarStart) {
      this.drawTimeLines({
        id: 'before-pickupOutOfBounds',
        driver: driverInfo,
        fromDateTime: calendarStart,
        toDateTime: moment(task.pickupEarliestDateTime)
          .add(-this.maxPickupDeviation, 'h')
          .format('YYYY-MM-DD HH:mm'),
        template: this.pickupOutOfBoundsTemplate,
      });
    }

    if (task.dropoffLatestDateTime < calendarEnd) {
      this.drawTimeLines({
        id: 'after-dropoffOutOfBounds',
        driver: driverInfo,
        fromDateTime: moment(task.dropoffLatestDateTime)
          .add(this.maxDropoffDeviation, 'h')
          .format('YYYY-MM-DD HH:mm'),
        toDateTime: calendarEnd,
        template: this.pickupOutOfBoundsTemplate,
      });
    }

    /*

    let pickupDaysBeforeWindow = moment(task.pickupEarliestDateTime)
      .add(0, 'h')
      .format('YYYY-MM-DD HH:mm');

    let pickupDaysAfterWindow = moment(task.pickupLatestDateTime)
      .add(this.maxPickupDeviation, 'h')
      .format('YYYY-MM-DD HH:mm');

    let dropoffDaysBeforeWindow = moment(task.dropoffEarliestDateTime)
      .add(-this.maxDropoffDeviation, 'h')
      .format('YYYY-MM-DD HH:mm');

    let dropoffDaysAfterWindow = moment(task.dropoffLatestDateTime)
      .add(0, 'h')
      .format('YYYY-MM-DD HH:mm');

    if (pickupDaysBeforeWindow > calendarStart) {
      this.drawTimeLines({
        id: 'before-pickupOutOfBounds',
        driver: driverInfo,
        fromDateTime: calendarStart,
        toDateTime: pickupDaysBeforeWindow,
        template: this.pickupOutOfBoundsTemplate,
      });
    }

    if (pickupDaysAfterWindow < calendarEnd) {
      this.drawTimeLines({
        id: 'after-pickupOutOfBounds',
        driver: driverInfo,
        fromDateTime: pickupDaysAfterWindow,
        toDateTime: calendarEnd,
        template: this.pickupOutOfBoundsTemplate,
      });
    }

    if (dropoffDaysBeforeWindow > calendarStart) {
      this.drawTimeLines({
        id: 'before-dropoffOutOfBounds',
        driver: driverInfo,
        fromDateTime: calendarStart,
        toDateTime: dropoffDaysBeforeWindow,
        template: this.dropoffOutOfBoundsTemplate,
      });
    }

    if (dropoffDaysAfterWindow > calendarEnd) {
      this.drawTimeLines({
        id: 'after-dropoffOutOfBounds',
        driver: driverInfo,
        fromDateTime: dropoffDaysAfterWindow,
        toDateTime: calendarEnd,
        template: this.dropoffOutOfBoundsTemplate,
      });
    }

     */

    // END OF "OUT OF BOUNDS PLOTS //

    // Default the "unassigned" calendar to any of the drivers
    if (
      this.supplierIds &&
      this.supplierIds.length == 1 &&
      driverInfo != null &&
      driverInfo.driverId == null
    ) {
      this.setDefaultAvailabilityForUnassigned(driverInfo);
    }

    this.drawTimeLines({
      id: 'pickup',
      driver: driverInfo,
      fromDateTime: task.pickupEarliestDateTime,
      toDateTime: task.pickupLatestDateTime,
      template: this.pickupWindowAreaTemplate,
    });

    this.drawTimeLines({
      id: 'dropoff',
      driver: driverInfo,
      fromDateTime: task.dropoffEarliestDateTime,
      toDateTime: task.dropoffLatestDateTime,
      template: this.dropoffWindowAreaTemplate,
    });

    if (driverInfo) {
      driverInfo.availability
        .filter((x) => x.available == false)
        .forEach((x, y) => {
          let start = new Date(x.exceptionDate).toDateString() + ' ' + this.hourRange[0] + ':00:00';
          let end =
            new Date(x.exceptionDate).toDateString() +
            ' ' +
            this.hourRange[this.hourRange.length - 1] +
            ':59:59';

          this.drawTimeLines({
            id: 'unavailable-' + y,
            driver: driverInfo,
            fromDateTime: start,
            toDateTime: end,
            template: this.unavailableAreaTemplate,
          });
        });
    }
  }

  private setDefaultAvailabilityForUnassigned(driverInfo: IDriverObject) {
    // Find the ONLY supplier and the first driver, and we use their availability
    // when trying to move an unassigned task

    const supplierId = this.supplierIds[0];
    const driver = this.drivers[0];

    if (driver != null) {
      driverInfo.availability = driver.availability;
    }
  }

  px2int(px: string) {
    return parseInt(px.replace(/[^\d.-]/g, ''));
  }

  dragTaskEnd($event, id) {
    this.activeGrid = true;

    // Cannot round the day above the start day..
    let taskId = id.split('-')[1];
    let task = this.tasks.find((x) => x.id == taskId);
    let newPickupTime = task.taskSupplierSchedule.specifiedPickUpTime;
    let newDropoffTime = task.taskSupplierSchedule.specifiedDropOffTime;

    this.rescheduleTask = task;

    this.rescheduleTask.reschedule = {
      pickupDateTime: new Date(newPickupTime),
      dropoffDateTime: new Date(newDropoffTime),
    };

    let draggedBox = this.getIDComputedStyle(id);
    let draggedBoxTransform = draggedBox.transform;
    let draggedBoxMatrix = new WebKitCSSMatrix(draggedBoxTransform);
    let offsetX = draggedBoxMatrix.m41;
    let offsetY = draggedBoxMatrix.m42;

    let th = this.getTaskHeight();

    if (this.moveMode == 'all') {
      const sortedIds = this.allTaskDivs
        .map((x) => {
          return x.id;
        })
        .sort((a, b) => a.localeCompare(b));

      const firstDiv = sortedIds[0];
      const lastDiv = sortedIds[sortedIds.length - 1];

      const firstDivStyle = this.getIDComputedStyle(firstDiv);
      const lastDivStyle = this.getIDComputedStyle(lastDiv);

      const firstDivNewTop = this.px2int(firstDivStyle.top) + offsetY;
      const firstDivNewLeft = this.px2int(firstDivStyle.left) + offsetX;

      const lastDivNewTop = this.px2int(lastDivStyle.top) + offsetY;
      const lastDivNewLeft = this.px2int(lastDivStyle.left) + offsetX;
      const lastDivNewRight = lastDivNewLeft + this.px2int(lastDivStyle.width);

      let startTime = this.getHourFromGrid(firstDivNewLeft);
      let startDay = this.getRowFromGrid(firstDivNewTop + this.getTaskHeight() / 2);

      let endTime = this.getHourFromGrid(lastDivNewRight);
      let endDay = this.getRowFromGrid(lastDivNewTop + this.getTaskHeight() / 2);

      newPickupTime = this.getNewTaskDate(this.startDate, startTime, startDay);
      newDropoffTime = this.getNewTaskDate(this.startDate, endTime, endDay);
    } else {
      let newTop;

      let originalTop = this.px2int(draggedBox.top);
      let newBottom = this.px2int(draggedBox.top) + this.px2int(draggedBox.height) + offsetY;
      let draggedBoxLeft = this.px2int(draggedBox.left);
      let draggedBoxWidth = this.px2int(draggedBox.width);
      let draggedBoxRight = draggedBoxLeft + draggedBoxWidth;

      if (this.moveMode == 'bottom' || this.moveMode == 'left') {
        newTop = originalTop;
      } else {
        newTop = originalTop + offsetY;
      }

      let startTime = this.getHourFromGrid(draggedBoxLeft + offsetX);
      let startDay = this.getRowFromGrid(newTop + 1);

      let endTime = this.getHourFromGrid(draggedBoxRight + offsetX);
      let endDay = this.getRowFromGrid(newBottom);

      if (this.moveMode == 'left') {
        newPickupTime = this.getNewTaskDate(this.startDate, startTime, startDay);
      }
      if (this.moveMode == 'right') {
        newDropoffTime = this.getNewTaskDate(this.startDate, endTime, endDay);
      }
      if (this.moveMode == 'bottom') {
        // Going back one day

        if (newBottom == originalTop) {
          newDropoffTime = moment(task.taskSupplierSchedule.specifiedDropOffTime)
            .subtract(1, 'days')
            .toISOString();
        } else {
          // We have tried to make the endDateTime before the startDateTime
          // So undo that
          if (newDropoffTime < newPickupTime) {
            newPickupTime = task.taskSupplierSchedule.specifiedPickUpTime;
            newDropoffTime = task.taskSupplierSchedule.specifiedDropOffTime;
          } else {
            newDropoffTime = this.getNewTaskDate(this.startDate, endTime, endDay);
          }
        }
      }
    }

    const newPickupDateObject = new Date(newPickupTime);
    const newDropoffDateObject = new Date(newDropoffTime);

    const pickupEarliestHoursMargin =
      -(newPickupDateObject.valueOf() - new Date(task.pickupEarliestDateTime).valueOf()) / 36e5;

    const pickupLatestHoursMargin =
      (newPickupDateObject.valueOf() - new Date(task.pickupLatestDateTime).valueOf()) / 36e5;

    const dropoffEarliestHoursMargin =
      -(newDropoffDateObject.valueOf() - new Date(task.dropoffEarliestDateTime).valueOf()) / 36e5;

    const dropoffLatestHoursMargin =
      (newDropoffDateObject.valueOf() - new Date(task.dropoffLatestDateTime).valueOf()) / 36e5;

    if (pickupEarliestHoursMargin > this.maxPickupDeviation) {
      this.messageService.ShowError(
        'Timing Error',
        'Task cannot be scheduled for pickup more than ' +
          this.maxPickupDeviation +
          ' hours before earliest pickup date/time',
        100,
      );
    } else if (pickupLatestHoursMargin > this.maxPickupDeviation) {
      this.messageService.ShowError(
        'Timing Error',
        'Task cannot be scheduled for pickup more than ' +
          this.maxPickupDeviation +
          ' hours after latest pickup date/time',
        100,
      );
    } else if (dropoffEarliestHoursMargin > this.maxDropoffDeviation) {
      this.messageService.ShowError(
        'Timing Error',
        'Task cannot be scheduled for delivery more than ' +
          this.maxDropoffDeviation +
          ' hours before earliest dropoff date/time',
        100,
      );
    } else if (dropoffLatestHoursMargin > this.maxDropoffDeviation) {
      this.messageService.ShowError(
        'Timing Error',
        'Task cannot be scheduled for delivery more than ' +
          this.maxDropoffDeviation +
          ' hours after latest dropoff date/time',
        100,
      );
    } else {
      let driver = null;

      // Do we have a driver on the task already ?
      if (task.driver != null) {
        driver = this.drivers.find((x) => x.driverId == task.driver.id);
      }

      // Unassigned task
      if (driver == null) {
        // If we only have one supplier, its safe to use any driver for availability
        if (this.supplierIds.length == 1) {
          driver = this.drivers[0];
        }
      }

      if (driver != null && this.isUnavailable(newPickupTime, newDropoffTime, driver)) {
        this.rescheduleTask.reschedule.pickupDateTime = new Date(newPickupTime);
        this.rescheduleTask.reschedule.dropoffDateTime = new Date(newDropoffTime);

        // Show dialog asking to confirm
        this.confirmAvailabilityDialog = true;
        return; // We don't want to plot times until they've been confirmed
      } else {
        this.setScheduleTimes(task, newPickupTime, newDropoffTime);
      }
    }

    this.redrawGridItems();
  }

  setScheduleTimes(task: ITaskInteractiveDTO, newPickupTime: string, newDropoffTime: string) {
    task.taskSupplierSchedule.specifiedPickUpTime = newPickupTime;
    task.taskSupplierSchedule.specifiedDropOffTime = newDropoffTime;
  }

  getNewTaskDate(startDate, hour, day) {
    let timeObject = new Date(startDate);
    let newDateTime = new Date(timeObject.getTime() + (hour * 3600000 + day * 86400000));
    let time = newDateTime.toISOString();
    return time;
  }

  getHourFromGrid(newX: number) {
    let hourWidth = this.getHourWidth();
    let hour = newX / hourWidth;

    hour = Math.round(hour / 0.25) * 0.25;

    hour = hour + this.hourRange[0];

    return hour;
  }

  getRowFromGrid(newY: number) {
    let dayHeight = this.getDayHeight();

    let day = Math.floor(newY / dayHeight);

    return day;
  }

  getTaskHeight() {
    let x = this.getIDComputedStyle('taskHeightSample');
    return this.px2int(x.height) - 1;
  }

  getDayHeight() {
    let x = this.getIDComputedStyle('grid-inner');
    return parseInt(x.height.slice(0, -2)) / this.daysInView;
  }

  getHourWidth() {
    let x = this.getIDComputedStyle('grid-inner');

    return parseInt(x.width.slice(0, -2)) / this.hourRange.length;
  }

  setMoveMode(moveMode: string) {
    this.moveMode = moveMode;
  }

  assignDriver(task: ITaskInteractiveDTO, driverInfo: IDriverObject) {
    this.newDriver = null;

    if (task != null) {
      this.newDriver = driverInfo;

      this.tasks
        .filter((x) => x.order.job.id == task.order.job.id)
        .forEach((jobtask) => {
          jobtask.previousDriver = deepClone(jobtask.driver);

          // This is so we can set the driver colour scheme on the task before we've saved to database
          jobtask.driver = {
            id: driverInfo.driver.id,
            depotId: driverInfo.driver.depotId,
            regionId: driverInfo.driver.region.id,
            depot: driverInfo.driver.depot,
            nickName: driverInfo.driver.nickName,
            supplier: driverInfo.supplier,
          };
        });

      if (task.order.job.supplierId == null) {
        this.acceptJobDialog = true;
      } else {
        this.taskUpdating = true;

        if (
          driverInfo.driver.supplier.id != task.order.job.supplierId &&
          task.order.job.supplierId != null
        ) {
          this.showSupplierChangeDialog(driverInfo);
        } else {
          this.confirmChangeDriver(this.selectedTask, driverInfo.driverId, 1, '');
        }
      }
    }
  }

  toggleDriver(driverInfo) {
    driverInfo.visible = !driverInfo.visible;
    this.redrawGridItems();
  }

  showSupplierChangeDialog(driverInfo) {
    this.supplierChangeDialog = true;
  }

  confirmChangeDriver(
    selectedTask: ITaskInteractiveDTO,
    driverId: number,
    reasonId: number,
    reasonComment: '',
  ) {
    this.supplierChangeDialog = false;

    this.jobsDeploymentService
      .changeDriver({
        taskId: selectedTask.id,
        driverId: driverId,
        reasonId: reasonId,
        reasonComment: reasonComment,
      })
      .then(async () => {
        this.clearSupplierTaskCache();
        this.refresh('ChangeDriver');
        this.selectedTask = null;
      });
  }

  onlyDriver(driver: IDriverObject) {
    this.onlyDriverId = this.onlyDriverId == driver.driverId ? null : driver.driverId;
    this.drivers.forEach(
      (x) => (x.visible = this.onlyDriverId == null || x.driverId == driver.driverId),
    );
    this.redrawGridItems();
  }

  private getDrivers(): Promise<any> {
    // This is the default
    this.supplierDrivers = [{ nickName: 'Unassigned', id: null, unavailable: [] }];

    // Get a list of suppliers from the tasks we've passed in
    let taskSuppliers = this.inputJobs.filter((x) => x.supplierId != null).map((x) => x.supplierId);

    // Merge in the suppliers we've selected at the top
    let mergedList = [...taskSuppliers, ...(this.supplierIds ?? [])];

    // Get a unique list of suppliers
    let uniqueList = Array.from(new Set(mergedList));

    // Add selected suppliers
    if (uniqueList && uniqueList.length > 0 && uniqueList.length < 100) {
      this.driverFilter = {
        filters: {
          supplierIdList: { value: uniqueList },
          availabilityFrom: { value: this.minDate },
          availabilityTo: { value: this.maxDate },
        },
      };

      return this.driverService.getList(this.driverFilter).then((driverlist) => {
        this.multipleDrivers = driverlist.length > 1;

        driverlist.forEach((driver) => {
          const exists = this.supplierDrivers.filter((x) => x.id == driver.id).length;

          if (driver.id != null && exists == 0) {
            this.supplierDrivers = [driver, ...this.supplierDrivers];
          }
        });
      });
    }

    return Promise.resolve();
  }

  driverChanges(): number {
    let pendingChanges = 0;

    // Only compare tasks where we have a supplier
    if (
      this.drivers != null &&
      this.savedState &&
      this.savedState.length > 0 &&
      this.tasks &&
      this.tasks.length > 0
    ) {
      pendingChanges = compare(
        this.tasks.filter((x) => x.order.job.supplierId != null).map((x) => x.taskSupplierSchedule),
        this.savedState
          .filter((x) => x.order.job.supplierId != null)
          .map((x) => x.taskSupplierSchedule),
      ).length;
    }

    this.pendingChanges = pendingChanges;

    if (this.pendingChangesUpdate) {
      this.pendingChangesUpdate.emit(this.pendingChanges);
    }

    return this.pendingChanges;
  }

  private saveState() {
    this.savedState = JSON.parse(JSON.stringify(this.tasks));
  }

  estimatedTimeDisplay(x: string) {
    if (x != '') {
      const z = x.split(':');
      return parseInt(z[0]) + ':' + z[1];
    }

    return '';
  }

  private async loadTaskData(searchDTO: TaskSearchRequestDTO) {
    const component = 'interactive-schedule-supplier-list';

    let tasksFromSupplierIds = { data: [] };
    let tasksFromJobIds = { data: [] };
    let earliestJobPickup;

    // Get Faceted Filter Selected Tasks
    if (searchDTO.jobIds != null && searchDTO.jobIds.length > 0) {
      tasksFromJobIds = await this.taskService.search({
        jobIds: searchDTO.jobIds,
        component: component,
      });

      const min = tasksFromJobIds.data.reduce(
        (prev, current) =>
          current.pickupEarliestDateTime < prev.pickupEarliestDateTime ? current : prev,
        tasksFromJobIds.data[0],
      );

      earliestJobPickup = min ? new Date(min.pickupEarliestDateTime) : null;

      // Reset the date if this task falls outside the range displayed
      if (min.pickupEarliestDateTime < this.minDate || min.pickupEarliestDateTime > this.maxDate) {
        this.initDays(earliestJobPickup);
        this.saveSettings('LoadTaskData');
      }
    }

    // Get Supplier Tasks for each supplier one at a time
    // This means we can select/deselect suppliers without having to get the entire list each time
    // And uses indexes better

    if (searchDTO.supplierIds != null && searchDTO.supplierIds.length > 0) {
      for (const supplierId of searchDTO.supplierIds) {
        // We may consider re-instating this for caching porpoises
        // if !(supplierId in this.supplierTasks)) {
        {
          const tasks = await this.taskService.search({
            supplierId: supplierId,
            component: component,
            specifiedPickupTimeFrom: this.minDate,
            specifiedDropoffTimeTo: this.maxDate,
          });

          this.supplierTasks[supplierId] = tasks;
        }
      }

      for (const [key, value] of Object.entries(this.supplierTasks)) {
        tasksFromSupplierIds.data = [...tasksFromSupplierIds.data, ...value.data];
      }
    }

    const mergedTasks = [...tasksFromSupplierIds.data, ...tasksFromJobIds.data];
    const uniqueTasks = uniqBy(mergedTasks, 'id');
    const newTaskList = [];

    uniqueTasks.forEach((x) => {
      const exists = this.tasks.find((y) => y.id == x.id);

      if (!exists) {
        newTaskList.push(x);
      } else {
        newTaskList.push(exists);
      }
    });

    this.tasks = newTaskList;

    const uniqueJobs = uniqBy(this.tasks, 'order.job.id');

    for (let job of uniqueJobs.filter((x) => x.order != null && x.order.job != null)) {
      const total = this.tasks.filter((x) => x.order.job.id == job.order.job.id).length;

      this.tasks
        .filter((x) => x.order.job.id == job.order.job.id)
        .forEach((y, i) => {
          y.xOfTotal = i + 1;
          y.totalTasksInJob = total;

          let pickupDateTime: string;
          let dropoffDateTime: string;

          // Add pickup + dropoff handover times here
          const handoverTimes = this.calculateHandoverTimes(y);
          const calculateOptimizedTimes = true;

          // If we don't have a supplier schedule, default to earliest times
          if (!y.taskSupplierSchedule) {
            if (calculateOptimizedTimes && y.estimateTime != '') {
              let durationArray = y.estimateTime.split(':');

              // If its too short, you won't be able to see it, show 60mins
              let durationMinutes = Math.max(
                60,
                parseInt(durationArray[0]) * 60 + parseInt(durationArray[1]),
              );

              if (handoverTimes != null) {
                durationMinutes +=
                  handoverTimes.pickupHandoverMinutes + handoverTimes.dropoffHandoverMinutes;
              }

              let pickupTime = moment(y.dropoffEarliestDateTime).add(-durationMinutes, 'minutes');
              pickupDateTime = pickupTime.format('YYYY-MM-DD HH:mm');

              // AVOID PICKUPS TOO EARLY
              // If the pickup is before 8am, see if it can be moved forward

              const minPickupMinutesSinceMidnight = 8 * 60;
              const pickupMinutes =
                moment(pickupDateTime).hour() * 60 + moment(pickupDateTime).minutes();

              dropoffDateTime = moment(y.dropoffEarliestDateTime).format('YYYY-MM-DD HH:mm');

              if (pickupMinutes < minPickupMinutesSinceMidnight) {
                const adjustmentMinutes = minPickupMinutesSinceMidnight - pickupMinutes;

                const newPickup = moment(pickupDateTime).add(adjustmentMinutes, 'minutes');

                const newDropoff = moment(newPickup).add(durationMinutes, 'minutes');

                // Take new times
                if (newDropoff <= moment(y.dropoffLatestDateTime)) {
                  pickupDateTime = moment(newPickup).format('YYYY-MM-DD HH:mm');
                  dropoffDateTime = newDropoff.format('YYYY-MM-DD HH:mm');
                }
              }
            } else {
              pickupDateTime = moment(y.pickupEarliestDateTime).format('YYYY-MM-DD HH:mm');
              dropoffDateTime = moment(y.dropoffLatestDateTime).format('YYYY-MM-DD HH:mm');
            }

            y.taskSupplierSchedule = {} as TaskScheduleDTO;
            y.taskSupplierSchedule.taskId = y.id;
            y.taskSupplierSchedule.specifiedPickUpTime = moment(pickupDateTime).toISOString();
            y.taskSupplierSchedule.specifiedDropOffTime = moment(dropoffDateTime).toISOString();

            if (handoverTimes != null) {
              y.order.customer.handoverTimes = [handoverTimes];
            }
          }
        });
    }

    // FIND OUT IF THE CALENDAR IS MOVING
    if (this.tasks && this.tasks.length > 0) {
      if (
        earliestJobPickup < new Date(this.minDate) ||
        earliestJobPickup > new Date(this.maxDate)
      ) {
        if (tasksFromJobIds.data.length > 0) {
          this.initDays(earliestJobPickup);
          this.calendarChanged();
        }
      }
    } else {
      this.tasks = [];
    }

    this.plotNewData('LoadTaskData');
  }

  calendarChanged() {
    if (this.supplierIds.length == 1) {
      this.updateSupplierAvailability(this.supplierIds[0]);
    }
  }

  async saveChanges() {
    this.savingChanges = true;

    let jobs = this.tasks.map((x) => x.order.job.id);
    const uniqueJobList = Array.from(new Set(jobs));

    for (let jobId of uniqueJobList) {
      const tasks = this.tasks.filter((x) => x.order.job.id == jobId);
      let job = tasks[0].order.job;
      const jobPreviously = this.savedState.filter((x) => x.order.job.id == jobId)[0].order.job;

      let differences = 0;

      // To prevent updating everything all the time, just find if anything has changed with this task/job
      tasks.forEach((task) => {
        const previously = this.savedState.find((x) => x.id == task.id);
        const difference = compare(previously.taskSupplierSchedule, task.taskSupplierSchedule);
        differences += difference.length;
      });

      if (differences > 0) {
        tasks.forEach((task) => {
          this.saveTaskSupplierSchedule(task);
        });
      }
    }

    this.saveState();
    this.savingChanges = false;
    this.refresh('saveChanges');
  }

  confirmAcceptJob(reassignTask: ITaskInteractiveDTO) {
    this.isVME ? this.allocateJob(reassignTask) : this.acceptJob(reassignTask);
  }

  acceptJob(reassignTask: ITaskInteractiveDTO) {
    const jobId = reassignTask.order.job.id;
    let tasks = this.tasks.filter((x) => x.order.job.id == jobId);

    let request: AcceptJobDTO = {
      jobId: jobId,
      requestChannel: RequestChannelType.SupplierInteractiveSchedule,
      supplierJobChannel: SupplierJobChannel.InteractiveSchedule,
      taskSupplierSchedules: tasks.map((task) => ({
        taskId: task.id,
        specifiedPickUpTime: new Date(task.taskSupplierSchedule.specifiedPickUpTime),
        specifiedDropOffTime: new Date(task.taskSupplierSchedule.specifiedDropOffTime),
        taskCollectionTravelMode: TaskCollectionTravelMode.Driving,
        noneSameDayDeliveryReasonId: null,
        carryoverAddress: task.taskSupplierSchedule.carryoverAddress,
      })),
    };

    this.supplierJobInteractionService.logSingleJobInteraction('BuyJobAttempt', jobId);

    this.supplierInboxJobsService.acceptJob(request).then((res) => {
      tasks.forEach((task) => {
        task.order.job.supplierId = reassignTask.driver.supplier.id;
      });

      if (res == JobAcceptResult.Success) {
        this.supplierJobInteractionService.logSingleJobInteraction('BuyJobSuccess', jobId);

        tasks.forEach((task) => {
          this.confirmChangeDriver(task, task.driver.id, 0, '');

          // Update the saved state so we don't report changes
          this.savedState.map((x) => (x.id == task.id ? task : x));
        });
      } else {
        if (res == JobAcceptResult.PreviouslyAccepted) {
          this.messageService.ShowError('Taken', 'This job has been already accepted');

          // Remove tasks from list as job is now gone
          tasks.forEach((task) => {
            this.tasks = this.tasks.filter((x) => x.id != task.id);
          });
        } else if (res == JobAcceptResult.TaskTypeRequirementNotMet) {
          this.messageService.ShowError(
            'Capability',
            "One or more orders in this Job no longer matches Supplier's capabilities.",
          );
        }
      }
    });

    this.hideAcceptJob(true, null);
  }

  allocateJob(reassignTask: ITaskInteractiveDTO) {
    const jobId = reassignTask.order.job.id;
    let tasks = this.tasks.filter((x) => x.order.job.id == jobId);

    let request: AllocateJobDTO = {
      jobId: jobId,
      supplierId: reassignTask.driver.supplier.id,
      price: reassignTask.order.job.buyItNowPrice,
      requestChannel: this.isVME
        ? RequestChannelType.VMEInteractiveSchedule
        : RequestChannelType.SupplierInteractiveSchedule,
      taskSupplierSchedules: tasks.map((task) => ({
        taskId: task.id,
        specifiedPickUpTime: new Date(task.taskSupplierSchedule.specifiedPickUpTime),
        specifiedDropOffTime: new Date(task.taskSupplierSchedule.specifiedDropOffTime),
        taskCollectionTravelMode: TaskCollectionTravelMode.Driving,
        noneSameDayDeliveryReasonId: null,
        carryoverAddress: task.taskSupplierSchedule.carryoverAddress,
      })),
    };

    this.jobsDeploymentService
      .allocateJob(request)
      .then((res) => {
        tasks.forEach((task) => {
          task.order.job.supplierId = reassignTask.driver.supplier.id;
        });

        tasks.forEach((task) => {
          this.confirmChangeDriver(task, task.driver.id, 0, '');

          // Update the saved state so we don't report changes
          this.savedState.map((x) => (x.id == task.id ? task : x));
        });
      })
      .catch((err) => {
        if (err.error && err.error.Message) {
          this.messageService.ShowError('Allocate Job', `${err.error.Message}`);
        } else {
          this.messageService.ShowError(
            'Allocate Job',
            `An error occurred when trying to allocate job to Supplier`,
          );
        }
      });

    this.hideAcceptJob(true, null);
  }

  saveTaskSupplierSchedule(task) {
    this.taskService
      .saveSupplierSchedule({
        taskId: task.id,
        specifiedPickUpTime: new Date(task.taskSupplierSchedule.specifiedPickUpTime),
        specifiedDropOffTime: new Date(task.taskSupplierSchedule.specifiedDropOffTime),
        taskCollectionTravelMode: TaskCollectionTravelMode.Driving,
        noneSameDayDeliveryReasonId: null,
        carryoverAddress: task.taskSupplierSchedule.carryoverAddress,
      })
      .then(() => {});
  }

  taskClick(taskId: number) {
    this.topLayer = taskId;
  }

  async taskSelect($event: MouseEvent, context: any) {
    // Unset we're reassigning
    if (this.selectedTask != null) {
      this.selectedTask = null;
      this.acceptJobDialog = true;
      return;
    }

    this.selectedTask = context.taskInfo;
    this.checkCapability(this.selectedTask.order.job.id, this.supplierIds);

    if (!this.multipleDrivers) {
      this.autoAssignDriver(this.selectedTask);
    }
  }

  private autoAssignDriver(task: ITaskInteractiveDTO) {
    this.assignDriver(task, this.drivers[0]);
  }

  private checkCapability(jobId: number, suppliers: number[]) {
    this.capacityMatchingService.suppliersCapableOfJob(jobId, suppliers).then((response) => {
      this.capableSuppliers = response.supplierIds;
    });
  }

  private suppliersChanged(currentValue: any, previousValue: any) {
    if (previousValue != currentValue && currentValue !== undefined) {
      this.refresh('SupplierChanged');
      this.calendarChanged();
      if (currentValue.length == 1) {
        this.updateSupplierAvailability(currentValue[0]);
      }
    }
  }

  updateSupplierAvailability(supplierId) {
    this.supplierScheduleService
      .getSupplierAvailability({
        filters: {
          supplierId: { value: supplierId },
          fromDate: { value: new Date(this.minDate) },
          toDate: { value: new Date(this.maxDate) },
        },
      })
      .then((x) => {
        if (x != null) {
          this.supplierAvailable = {};

          x.supplierAvailabilityExceptions.forEach((y) => {
            this.supplierAvailable[moment(y.exceptionDate).format('YYYY-MM-DD')] =
              y.availabilityState == SupplierAvailabilityStateEnum.available;
          });

          let driverAvailability: ISupplierAvailabilityException[] =
            x.supplierAvailabilityExceptions.map((y) => {
              return {
                id: y.id,
                exceptionDate: y.exceptionDate,
                availabilityState: y.availabilityState,
              };
            });

          // Update availability for this supplier drivers (inc the unassigned)
          this.drivers
            .filter((x) => (x.supplier && x.supplier.id == supplierId) || x.driverId == null)
            .forEach((driver) => {
              driver.availability = driverAvailability;
            });
        }
      });
  }

  driverTooltip(driverInfo: IDriverObject) {
    let companyName = '';

    if (driverInfo.driverId == null) {
      return 'N/A';
    }

    if (driverInfo.driver && driverInfo.driver.supplier !== undefined && this.isVME) {
      companyName = '<div>' + driverInfo.driver.supplier.name + '</div>';
    }

    return (
      "<div class='tool-drivername'>" +
      (driverInfo.driver.firstName || '') +
      ' ' +
      (driverInfo.driver.surname || '') +
      '</div> ' +
      companyName
    );
  }

  cancelChangeDriver(task: ITaskInteractiveDTO) {
    this.newDriver = null;
    this.supplierChangeDialog = false;

    this.revertDriver(task);
  }

  revertDriver(task: ITaskInteractiveDTO) {
    this.tasks
      .filter((x) => x.order.job.id == task.order.job.id)
      .forEach((jobtask) => {
        // console.log("UPDATING DRIVER TO ", jobtask.previousDriver);
        jobtask.driver = jobtask.previousDriver;
      });
  }

  clearSupplierTaskCache() {
    this.supplierTasks = []; // Clear cache of supplier tasks for given date range
  }

  newDateChosen($event) {
    this.clearSupplierTaskCache();
    this.showCalendar = false;
    this.initDays(new Date($event));
    this.calendarChanged();
    this.dateChangeEvent.emit({ minDate: this.minDate, maxDate: this.maxDate });
    this.refresh('NewDateChosen');
    this.saveSettings('new DateChosen');
  }

  isCapable(driver: any) {
    if (driver && driver.driver && driver.driver.supplier) {
      return this.capableSuppliers.includes(driver.driver.supplier.id);
    }
    return false;
  }

  hasChanged(taskInfo: any) {
    // We don't acknowledge changes to a task until it's been assigned a supplier
    if (taskInfo.order.job.supplierId == null) {
      return 0;
    }

    if (this.savedState) {
      const previously = this.savedState.find((x) => x.id == taskInfo.id);
      const difference = compare(previously.taskSupplierSchedule, taskInfo.taskSupplierSchedule);
      return difference.length > 0;
    }

    return 0;
  }

  hideAcceptJob(success: boolean, task?: ITaskInteractiveDTO) {
    if (!success) {
      this.revertDriver(task);
    }

    this.acceptJobDialog = false;
    this.selectedTask = null;
  }

  removeJob($event, id) {
    this.inputJobs = this.inputJobs.filter((x) => x.jobId != id);
    this.selectedTask = null;
    this.inputJobsChangeEvent.emit(this.inputJobs);
  }

  async changeSupplierStatus(exceptionDate: string) {
    if (this.supplierIds.length != 1) {
      return;
    }

    const supplierId = this.supplierIds[0];
    const dateString = moment(exceptionDate).format('YYYY-MM-DD');
    const available =
      this.supplierAvailable != null && this.supplierAvailable[dateString]
        ? !this.supplierAvailable[dateString]
        : true;

    this.setSupplierAvailability(supplierId, dateString, available);
  }

  setSupplierAvailability(supplierId: number, dateString: string, available: boolean) {
    if (supplierId != null) {
      this.supplierScheduleService
        .setSupplierAvailabilityDate(this.supplierIds[0], dateString, available)
        .then(() => {
          this.updateSupplierAvailability(supplierId);
        });
    }
  }

  isSupplierAvailable(day: any) {
    const x = moment(day).format('YYYY-MM-DD');

    if (this.supplierAvailable != null) {
      return this.supplierAvailable[x];
    }
    return null;
  }

  private isUnavailable(fromDate: string, toDate: string, driver: IDriverObject) {
    const days = this.daysArray(fromDate, toDate);
    let conflict = false;

    if (driver != null) {
      days.forEach((day) => {
        if (
          driver.availability.filter(
            (x) =>
              x.availabilityState != SupplierAvailabilityStateEnum.available &&
              x.availabilityState != SupplierAvailabilityStateEnum.unset &&
              moment(x.exceptionDate).format('YYYY-MM-DD') == day.ymd,
          ).length > 0
        ) {
          conflict = true;
        }
      });
    }

    return conflict;
  }

  private plotPostIts() {
    this.postIts.forEach((x) => {
      // Get date/time offsets
      this.drawTimeLines({
        id: 'POSTIT-' + x.id,
        fromDateTime: x.noteDateFrom,
        toDateTime: x.noteDateTo,
        template: this.postItTemplate,
        type: 'note',
        driver: this.drivers[0],
        data: {
          id: x.id,
          isVisible: true,
          note: x.note,
          editMode: false,
          noteDateFrom: x.noteDateFrom,
          noteDateTo: x.noteDateTo,
          driverId: x.driverId,
        } as IScheduleNoteDTO,
      });
    });
  }

  private plotOutOfHours() {
    const fromDate = this.startDate;
    const toDate = moment(this.startDate).add(this.daysInView - 1, 'days');
    const days = this.daysArray(fromDate, toDate);

    days.forEach((day) => {
      let weekDay = moment(day.ymd).format('ddd');

      if (weekDay == 'Sun' || weekDay == 'Sat') {
        this.drawTimeLines({
          id: 'weekend-' + day.ymd,
          fromDateTime: day.ymd + ' ' + this.hourRange[0] + ':00',
          toDateTime: day.ymd + ' ' + this.hourRange[this.hourRange.length - 1] + ':59',
          template: this.outOfHoursTemplate,
        });
      } else {
        // 24 hour clock
        if (!this.workingHours) {
          this.drawTimeLines({
            id: 'morning-' + day.ymd,
            fromDateTime: day.ymd + ' 00:00',
            toDateTime: day.ymd + ' 06:59',
            template: this.outOfHoursTemplate,
          });

          this.drawTimeLines({
            id: 'evening-' + day.ymd,
            fromDateTime: day.ymd + ' 18:00',
            toDateTime: day.ymd + ' 23:59',
            template: this.outOfHoursTemplate,
          });
        }
      }
    });
  }

  availableConfirm(acceptJob: boolean, setAvailable: boolean) {
    this.confirmAvailabilityDialog = false;

    if (setAvailable) {
      const days = this.daysArray(
        this.rescheduleTask.reschedule.pickupDateTime,
        this.rescheduleTask.reschedule.dropoffDateTime,
      );
      const supplierId =
        this.supplierIds.length == 1
          ? this.supplierIds[0]
          : this.rescheduleTask.order.job.supplierId;

      days.forEach((day) => {
        this.setSupplierAvailability(supplierId, day.ymd, true);
      });
    }

    if (acceptJob) {
      this.setScheduleTimes(
        this.rescheduleTask,
        moment(this.rescheduleTask.reschedule.pickupDateTime).format('YYYY-MM-DD HH:mm'),
        moment(this.rescheduleTask.reschedule.dropoffDateTime).format('YYYY-MM-DD HH:mm'),
      );
    }

    this.redrawGridItems();
  }

  private initHandovers() {
    this.organisationService.getHandoverTimes(null).then((x) => {
      this.defaultHandoverTimes = x;
    });
  }

  private calculateHandoverTimes(y: ITaskInteractiveDTO): IHandoverTime {
    // What task type is it ?
    const taskTypeId = y.taskTypeId;
    let handoverTimes = null;

    if (y.order.customer.handoverTimes != null && y.order.customer.handoverTimes) {
      handoverTimes = y.order.customer.handoverTimes.find((x) => x.taskTypeId == taskTypeId);
    }

    if (handoverTimes == null) {
      handoverTimes = this.defaultHandoverTimes.find((x) => x.taskTypeId == taskTypeId);
    }

    return handoverTimes;
  }

  dragDisabled(context) {
    return !this.isVME && !context.taskInfo.canReschedule;
  }

  taskFinished(context: any) {
    if (!context.taskInfo || !context.taskInfo.order || !context.taskInfo.order.job) {
      return false;
    }

    return [JobStatus.Completed, JobStatus.Closed].includes(context.taskInfo.order.job.status);
  }

  addPostIt({ startDateTime = '', endDateTime = '' }) {
    if (this.enablePostIts) {
      if (startDateTime == '') {
        startDateTime = '2022-11-15 10:00';
        endDateTime = '2022-11-15 11:00';
      }

      this.postIts.push({
        id: 1,
        driverId: this.drivers[0].driverId,
        noteDateFrom: startDateTime,
        noteDateTo: endDateTime,
        isVisible: true,
        note: '',
      });

      this.plotPostIts();
    }
  }

  toggleNotes() {}

  removePostIt(context: any) {}

  editPostIt(context: IContext) {
    this.currentContext = context;
    this.editPostItDialog = true;
  }

  saveNoteInfo() {
    this.editPostItDialog = false;

    this.taskService.saveDriverNote({
      id: this.currentNote.id,
      driverId: this.currentNote.driverId,
      note: this.currentNote.note,
      noteDateFrom: this.currentNote.noteDateFrom,
      noteDateTo: this.currentNote.noteDateTo,
    });
  }

  addNoteHere($event: MouseEvent) {
    let hourWidth = this.getHourWidth();
    let startDay = this.getRowFromGrid($event.offsetY);
    let startTime = this.getHourFromGrid($event.offsetX - hourWidth / 2);
    let postItStart = this.getNewTaskDate(this.startDate, startTime, startDay);
    let postItEnd = this.getNewTaskDate(this.startDate, startTime + 1, startDay);

    this.addPostIt({ startDateTime: postItStart, endDateTime: postItEnd });

    //this.editPostIt();
  }

  deletePostIt(currentNote: IScheduleNoteDTO) {}

  viewJob(jobId) {
    window.open('/app/jobscreen/' + jobId);
  }

  toggleTooltip(event, taskInfo: any) {
    const elementId = document.getElementById('tooltip-popup-' + taskInfo.id);

    if (elementId.style.display == 'none' || !elementId.style.display) {
      elementId.style.display = 'block';
      const position = this.tooltipPosition(taskInfo.id);
      elementId.style.left = position[0] + 'px';
      elementId.style.top = position[1] + 'px';

      this.taskPopupCode(taskInfo, []).then((mapCode) => {
        this.taskMapCode[taskInfo.id] = mapCode;
      });
    } else {
      elementId.style.display = 'none';
    }
  }

  tooltipPosition(id) {
    // Get button

    const button = document.getElementById('show-tooltip-' + id);
    const buttonRect = button.getBoundingClientRect();
    const popup = document.getElementById('tooltip-popup-' + id);
    const popupRect = popup.getBoundingClientRect();

    let x = buttonRect.left + 20;
    let y = buttonRect.top - popupRect.height / 2;

    // If it won't fit to the right, move it to the left
    if (x + popupRect.width > window.innerWidth) {
      x = buttonRect.left - popupRect.width - 20;
    }

    if (y < 0) {
      y = 0;
    }

    // If it won't fit below, move it above
    if (y + popupRect.height > window.innerHeight) {
      y = window.innerHeight - popupRect.height;
    }

    return [x, y];
  }

  printJobs() {
    let taskList = [];

    this.drivers
      .filter((x) => x.visible == true)
      .forEach((d) => {
        d.tasks.forEach((t: ITaskInteractiveDTO, index) => {
          taskList.push(t.id);
        });
      });

    this.taskService.printTasks({
      tasks: taskList.join(','),
    });
  }

  longPress(context: any, mouseClick: any) {
    if (this.layerMode) {
      return;
    }

    // Get coords of grid
    const grid = document.getElementById('grid-inner').getBoundingClientRect();
    const boxClicked = document.getElementById(context.id).getBoundingClientRect();

    // Find where on the grid we clicked
    const offsetX = mouseClick.x - grid.left;
    const offsetY = mouseClick.y - grid.top;

    // Calculate the day/hour from the grid
    const rowChosen = this.getRowFromGrid(offsetY);
    const hourChosen = this.getHourFromGrid(offsetX);

    const dateTimeClicked = this.getNewTaskDate(this.startDate, hourChosen, rowChosen);

    const driverId = context.driver.driverId;
    const driverTasks = this.drivers.find((x) => x.driverId == driverId).tasks;

    this.overlappingTasks = driverTasks
      .filter(
        (x) =>
          x.taskSupplierSchedule.specifiedPickUpTime <= dateTimeClicked &&
          x.taskSupplierSchedule.specifiedDropOffTime >= dateTimeClicked,
      )
      .sort((a, b) => {
        return a.taskSupplierSchedule.specifiedPickUpTime.localeCompare(
          b.taskSupplierSchedule.specifiedPickUpTime,
        );
      });

    if (this.overlappingTasks.length > 0) {
      this.showOverlappingTasks = true;

      let popup = document.getElementById('overlappingTasks');
      let popupHeight = 35 + this.overlappingTasks.length * 22;

      popup.style.setProperty('left', mouseClick.x - 100 + 'px');
      popup.style.setProperty('height', popupHeight + 'px');
      popup.style.setProperty('top', boxClicked.top - popupHeight + 'px');
    }
  }

  mouseDown($event: MouseEvent) {
    this.mousePosition = { x: $event.x, y: $event.y };
  }

  bringTaskToFront(taskId) {
    this.topLayer = taskId;
  }

  undoChanges() {
    this.tasks = [...this.savedState];
    this.driverChanges();
    this.refresh('UndoChanges');
  }

  toggleLayerMode() {
    this.layerMode = !this.layerMode;
    this.plotNewData('ToggleLayer');
    this.saveSettings('ToggleLayer');
  }
}
